import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/desa')({
  component: DesaLayout,
})

function DesaLayout() {
  return <Outlet />
}
